"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _List = _interopRequireDefault(require("../List/List"));
var _Popover = _interopRequireDefault(require("../Popover"));
const Menu = props => {
  const {
    className = 'menu',
    children,
    listData,
    open = false,
    trigger = 'click',
    position = 'top-center',
    maxwidth,
    maxheight,
    width = 'auto',
    hasArrow = false,
    preventcloseonblur = true,
    fit = 'medium',
    listChange
  } = props;
  return (0, _jsxRuntime.jsx)(_Popover["default"], (0, _extends2["default"])({
    className: className,
    content: (0, _jsxRuntime.jsx)(_List["default"], {
      listData: listData,
      noBorder: true,
      onSelect: listChange
    }),
    open: open,
    trigger: trigger,
    position: position,
    maxheight: maxheight,
    width: width,
    hasArrow: hasArrow,
    preventcloseonblur: preventcloseonblur,
    fit: fit,
    maxwidth: maxwidth
  }, {
    children: children
  }));
};
var _default = exports["default"] = Menu;